/* eslint-disable */
(function() {
  const menuButton = document.querySelector('.header .navigation-mobile .buttons');

  function toggleMenu() {
    const menuContent = document.querySelector('.header .navigation_content');
    const header = document.querySelector('.header');

    menuButton.classList.toggle('open');
    menuContent.classList.toggle('open');
    document.body.classList.toggle('hidden-overflow');

    menuContent.setAttribute('style', `display:block;top:${header.offsetHeight}px;height:${window.outerHeight - header.offsetHeight}px;overflow:auto;`);
  }

  if (menuButton) {
    menuButton.addEventListener('click', toggleMenu);
  }

  window.addEventListener('resize', () => {
    const menuContent = document.querySelector('.header .navigation_content');

    if (window.innerWidth >= 1024) {
      menuContent.removeAttribute('style');
    } else {
      if (menuContent.classList.contains('open')) {
        const header = document.querySelector('.header');
        const wpadmin = document.querySelector('#wpadminbar');
        const heightDiff = wpadmin ? header.offsetHeight + wpadmin.offsetHeight : header.offsetHeight;
        menuContent.setAttribute('style', `display:block;top:${header.offsetHeight - 10}px;height:${window.outerHeight - heightDiff}px;overflow:auto;`);
      }
    }
  });

  const menuItems = document.querySelectorAll('.header .navigation_content .menu > .menu-item-has-children');

  function toggleSubMenu(e) {
    const subMenu = e.currentTarget.querySelector('.sub-menu');
    subMenu.setAttribute('style', `top:${e.target.clientHeight}px`);
    subMenu.classList.toggle('open');
  }

  for (const menuItem of menuItems) {
    if (window.innerWidth >= 1024) {
      menuItem.addEventListener('mouseenter', toggleSubMenu);
      menuItem.addEventListener('mouseleave', toggleSubMenu);
    } else {
      menuItem.addEventListener('click', toggleSubMenu);
    }
  }

})();
